import { render, staticRenderFns } from "./PaymentHistoryTable.vue?vue&type=template&id=327d38f3"
import script from "./PaymentHistoryTable.vue?vue&type=script&lang=js"
export * from "./PaymentHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./PaymentHistoryTable.vue?vue&type=style&index=0&id=327d38f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports